import HotelCardPriceBlock from './HotelCardPriceBlock';

export default HotelCardPriceBlock;
